import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/dragon-tiles/$siteId/broadcast")({
  component: RouteComponent,
  beforeLoad: ({ params, location }) => {
    // Since the index route acts as a layout we will redirect anyone who accesses it to the list page. This should only happen if they attempt to do so through manual manipulation of the URL.
    const isIndexRoute = location.pathname.split("/").pop() === "broadcast";
    if (isIndexRoute) {
      throw redirect({
        to: "/dragon-tiles/$siteId/broadcast/list",
        params: { siteId: params.siteId },
      });
    }
  },
});

function RouteComponent() {
  return <Outlet />;
}
